import { useEffect, useState } from 'react';
import FJAppConstant from './constants/FJAppConstant.js';
import styles from './App.module.less';
import FJLocalStore from './store/FJLocalStore';
import { useDispatch, useSelector } from 'react-redux';
import FJUtil from './util/FJUtil.js';
import FJModals from './components/FJModals/FJModals.jsx';
import FJActionCommon from './redux/action/FJActionCommon.js';
import FJImageToImage from './components/FJImageToImage';
import FJImageManipulation from './components/FJImageManipulation';
import FJClothesChanger from './components/FJClothesChanger';
import FJFaceSwap from './components/FJFaceSwap';
import FJImageEnhancer from './components/FJImageEnhancer';
import FJTextToImage from './components/FJTextToImage/index.jsx';
import FJImageExtender from './components/FJImageExtender/index.jsx';
import FJFake3d from './components/FJFake3d/index.jsx';
import FJConstant from './constants/FJConstant.js';
import FJObjectErase from './components/FJObjectErase/index.jsx';
import FJHeaderContainer from './components/FJMainPreview/FJHeader/FJHeaderContainer.jsx';
import useIsMobile from './hooks/useIsMobile.js';
import FJMobileHeaderContainer from './components/FJMainPreview/FJMobileHeader/FJMobileHeaderContainer.jsx';
import FJMobileImageToImage from './components/FJMobileImageToImage/index.jsx';
import FJMobileTextToImage from './components/FJMobileTextToImage/index.jsx';
import FJPhotoRemoveBg from './components/FJPhotoRemoveBg/index.jsx';
import FJAIVideoGenerator from './components/FJAIVideoGenerator/index.jsx';
import FJMobileImageManipulation from './components/FJMobileImageManipulation/index.jsx';
import FJMobileImageEnhancer from './components/FJMobileImageEnhancer/index.jsx';
import FJVideoRemoveBg from './components/FJVideoRemoveBg/index.jsx';
import FJMobileFaceSwap from './components/FJMobileFaceSwap/index.jsx';
import FJActionModal from './redux/action/FJActionModal.js';
import FJAIAudioGenerator from './components/FJAIAudio/index.jsx';
import FJHeaderContainerWithEditPage from './components/FJMainPreview/FJHeader/FJHeaderContainerWithEditPage.jsx';
import FJEvent from './store/FJEvent.js';
import FJAIToolAPI from './api/FJAIToolAPI.jsx';
import FJMobileImageExtender from './components/FJMobileImageExtender/index.jsx';
import FJMobileObjectErase from './components/FJMobileObjectErase/index.jsx';
import FJAiVideoDub from './components/FJAiVideoDub/index.jsx';
import {
    setCouponData,
    setCurrentCountryMonetary,
    setCurrentCountryMonetaryISO,
    setExchangeRateAction,
    setSliceIsShowMobileGiftBtu,
} from './redux/slices/FJSliceCommon.js';
import FJLimitedCouponStore from './store/FJLimitedCouponStore.js';
import FJActionLimitedCoupon from './redux/action/FJActionLimitedCoupon.js';
import FJActionAiHistoryCommon from './redux/action/FJActionAiHistoryCommon.js';
import FJAITextBasedEditing from './components/FJTextBasedEditing/index.jsx';
import FJTextToVideo from './components/FJTextToVideo/index.jsx';

// 处理promise的reject不会向sentry发送报告
window.addEventListener('unhandledrejection', event => {
    event.preventDefault();
});

// 处理promise的reject不会向sentry发送报告
window.addEventListener('unhandledrejection', event => {
    event.preventDefault();
});

let _disposable = false;

function App() {
    const dispatch = useDispatch();
    const appType = useSelector(state => state.common.appType);
    const [isLoading, setIsLoading] = useState(true);
    const isMobile = useIsMobile();

    // TODO: 测试

    useEffect(() => {
        if (document.getElementById('app-entry-loading')) {
            document.getElementById('app-entry-loading').remove();
        }
        FJLocalStore.initLanguage(() => {
            setIsLoading(false);
        });
        dispatch(FJActionCommon.initProjectInfoAction());
    }, [dispatch]);

    useEffect(() => {
        // 引入本地字体,用于调试
        if (!FJUtil.isLocalhost()) return;
        let link = document.createElement('link');
        link.href = '../public/fonts/roboto-font.css';
        link.rel = 'stylesheet';
        link.type = 'text/css';
        document.getElementsByTagName('head')[0].appendChild(link);

        // 组件卸载时移除引入的CSS
        return () => {
            document.getElementsByTagName('head')[0].removeChild(link);
        };
    }, []);

    useEffect(() => {
        //更新用户积分（包括header）
        let unSubscribeUpdateCreditsSubscribe = () => {};
        let unSubscribeDiscountSubscribe = () => {};
        // login btn 也使用此事件更新
        if (window.fj && window.fj.event && window.fj.event.subscribe) {
            unSubscribeUpdateCreditsSubscribe = window.fj.event.subscribe('UPDATE_USER_CREDITS', bool => {
                dispatch(FJActionCommon.updateUserCreditsInfoAction(bool));
            });

            // 使用折扣购买积分回调
            unSubscribeDiscountSubscribe = window.fj.event.subscribe('USE_DISCOUNT_OFF', () => {
                dispatch(setSliceIsShowMobileGiftBtu(false));
            });
        }

        return () => {
            unSubscribeUpdateCreditsSubscribe();
            unSubscribeDiscountSubscribe();
        };
    }, [dispatch]);
    useEffect(() => {
        //登陆相关事件处理
        const _login = () => {
            dispatch(FJActionCommon.initProjectInfoAction());
            dispatch(FJActionAiHistoryCommon.loginAfterAction());
            // TODO 手机端登录后手动更新一次信息
            if (isMobile) {
                dispatch(FJActionLimitedCoupon.updateDiscountLimitTimeDataAction());
            }
        };
        const _loginOut = () => {
            location.reload();
        };
        if (window.fjuser && window.fjuser.addListener) {
            const { login, logout } = window.fjuser.eventType;
            window.fjuser.addListener(login, _login);
            window.fjuser.addListener(logout, _loginOut);
        }
        // 订阅页事件切换团队/用户弹窗
        if (window.fj && window.fj.event && window.fj.event.subscribe) {
            window.fj.event.subscribe(FJConstant.ACCOUNT_CHANGE, () => {
                dispatch(FJActionModal.accountChangesModalAction());
            });
        }
        FJEvent.subscribe(FJConstant.USER_SPACE_CHANGE, type => {
            dispatch(FJActionCommon.userSpaceChangeAction(type));
        });
        return () => {
            if (window.fjuser && window.fjuser.addListener) {
                const { login, logout } = window.fjuser.eventType;
                window.fjuser.removeListener(login, _login);
                window.fjuser.removeListener(logout, _loginOut);
            }
        };
    }, [dispatch, isMobile]);
    useEffect(() => {
        const tool = FJUtil.getToolName();
        FJUtil.eaLog('ai tool generates page visit', { tool });

        FJUtil.eaLog('2025_4_10_20%_off_ab_test_visit', { tool, 'page type': FJUtil.getAB() });
    }, [dispatch]);

    useEffect(() => {
        if (!FJUtil.isLogin() || FJUtil.isFreePayment()) {
            if (appType === FJAppConstant.IMAGE_TO_IMAGE) {
                FJUtil.eaLog('AI Tools guide AB trigger 2025.4.14', { tool: 'image to image', AB: FJUtil.getAB() });
            } else if (appType === FJAppConstant.TEXT_TO_IMAGE) {
                FJUtil.eaLog('AI Tools guide AB trigger 2025.4.14', { tool: 'text to image', AB: FJUtil.getAB() });
            }
        }
    }, [appType]);

    useEffect(() => {
        if (!isMobile) return;

        // 禁止用户缩放
        // 创建一个新的meta元素
        const meta = document.createElement('meta');
        // 设置meta元素的属性
        meta.setAttribute('name', 'viewport');
        meta.setAttribute(
            'content',
            'width=device-width, initial-scale=1.0,minimum-scale=1, maximum-scale=1.0, user-scalable=no,viewport-fit=cover',
        );
        // 将meta元素添加到head中
        document.head.appendChild(meta);
    }, [isMobile]);

    useEffect(() => {
        window.AI_TOOL_API = FJAIToolAPI;
    }, []);

    // 支付页使用的打开优惠券窗口的方法
    useEffect(() => {
        window.optenTimeDiscountPanel = (disposable = false) => {
            if (disposable && _disposable) return;
            if (FJLimitedCouponStore.isUsedCoupon()) {
                if (disposable) _disposable = true;
                dispatch(FJActionModal.setTimeDiscountPanelDataAction(true));
                FJUtil.eaLog('ai_credits_20%_off_entrance_click', {
                    entrance: 'original_price_close',
                });
            }
        };
    }, []);

    // 初始化用户国家、汇率
    useEffect(() => {
        if (window.fj && window.fj.exchangeRate) {
            let tempExchangeRate = {
                area_code: 'US',
                currency_code: 'USD',
                currency_symbol: '$',
                rate: 0,
            };

            try {
                if (window.fj.exchangeRate.should_use_currency.can_ab_test) {
                    //
                    //
                } else {
                    if (window.fj.exchangeRate.should_use_currency.code === 'USD') {
                        //
                    } else {
                        tempExchangeRate = {
                            ...window.fj.exchangeRate,
                            currency_code: window.fj.exchangeRate.should_use_currency.code,
                            currency_symbol: window.fj.exchangeRate.should_use_currency.symbol,
                            rate:
                                window.fj.exchangeRate.should_use_currency.code === 'EUR'
                                    ? 1
                                    : window.fj.exchangeRate.rate,
                        };
                    }
                }
            } catch (e) {
                if (window.fj.exchangeRate?.area_code === 'IN') {
                    tempExchangeRate = { ...window.fj.exchangeRate };
                } else {
                    //
                }
            }

            const { area_code, currency_code, currency_symbol, rate } = tempExchangeRate;
            if (area_code && currency_code && currency_symbol && rate && parseFloat(rate)) {
                dispatch(setCurrentCountryMonetaryISO(currency_code));
                dispatch(setCurrentCountryMonetary(currency_symbol));
                dispatch(setExchangeRateAction(parseFloat(rate)));
            }
        }

        if (window.user_limited_time_coupon_info) {
            dispatch(setCouponData(window.user_limited_time_coupon_info));
        }
    }, []);

    useEffect(() => {
        return FJEvent.subscribe('UPDATE_COUPON_DATA', data => {
            dispatch(setCouponData(data));
        });
    }, []);

    if (isLoading) {
        return null;
    }

    const renderWebApp = () => {
        let App = null;
        switch (appType) {
            case FJAppConstant.IMAGE_TO_IMAGE:
                App = FJImageToImage;
                break;
            case FJAppConstant.PHOTO_RESTORATION:
            case FJAppConstant.PHOTO_COLORIZE:
                App = FJImageManipulation;
                break;
            case FJAppConstant.FACE_SWAP:
                App = FJFaceSwap;
                break;
            case FJAppConstant.CLOTHES_CHANGER:
                App = FJClothesChanger;
                break;
            case FJAppConstant.IMAGE_ENHANCER:
                App = FJImageEnhancer;
                break;
            case FJAppConstant.TEXT_TO_IMAGE:
                App = FJTextToImage;
                break;
            case FJAppConstant.IMAGE_EXTENDER:
                App = FJImageExtender;
                break;
            case FJAppConstant.FAKE_3D:
                App = FJFake3d;
                break;
            case FJAppConstant.OBJECT_ERASER:
                App = FJObjectErase;
                break;
            case FJAppConstant.PHOTO_REMOVE_BG:
                App = FJPhotoRemoveBg;
                break;
            case FJAppConstant.AI_VIDEO_GENERATOR:
                App = FJAIVideoGenerator;
                break;
            case FJAppConstant.VIDEO_REMOVE_BG:
                App = FJVideoRemoveBg;
                break;
            case FJAppConstant.AI_AUDIO_GENERATOR:
                App = FJAIAudioGenerator;
                break;
            case FJAppConstant.AI_VIDEO_DUB:
                App = FJAiVideoDub;
                break;
            case FJAppConstant.AI_TEXT_BASED_EDITING:
                App = FJAITextBasedEditing;
                break;
            case FJAppConstant.TEXT_TO_FULL_VIDEO:
            case FJAppConstant.BLOG_URL_TO_VIDEO:
            case FJAppConstant.PRODUCT_URL_TO_VIDEO:
            case FJAppConstant.PPT_TO_VIDEO:
                App = FJTextToVideo;
                break;
            default:
                break;
        }
        return (
            <>
                {window.isEditPage ? <FJHeaderContainerWithEditPage /> : <FJHeaderContainer />}
                <div className={styles.app_box}>{App && <App />}</div>
            </>
        );
    };
    const renderMobileApp = () => {
        let MobileApp = null;
        switch (appType) {
            case FJAppConstant.IMAGE_TO_IMAGE:
                MobileApp = FJMobileImageToImage;
                break;
            case FJAppConstant.TEXT_TO_IMAGE:
                MobileApp = FJMobileTextToImage;
                break;
            case FJAppConstant.PHOTO_RESTORATION:
            case FJAppConstant.PHOTO_COLORIZE:
                MobileApp = FJMobileImageManipulation;
                break;
            case FJAppConstant.IMAGE_ENHANCER:
                MobileApp = FJMobileImageEnhancer;
                break;
            case FJAppConstant.FACE_SWAP:
                MobileApp = FJMobileFaceSwap;
                break;
            case FJAppConstant.IMAGE_EXTENDER:
                MobileApp = FJMobileImageExtender;
                break;
            case FJAppConstant.OBJECT_ERASER:
                MobileApp = FJMobileObjectErase;
                break;
            // case FJAppConstant.CLOTHES_CHANGER:
            //     MobileApp = FJClothesChanger;
            //     break;

            // case FJAppConstant.IMAGE_EXTENDER:
            //     MobileApp = FJImageExtender;
            //     break;
            // case FJAppConstant.FAKE_3D:
            //     MobileApp = FJFake3d;
            //     break;
            default:
                break;
        }
        return (
            <div className={styles.mobile_box}>
                <FJMobileHeaderContainer />
                {MobileApp && <MobileApp />}
            </div>
        );
    };
    return (
        <>
            {isMobile ? renderMobileApp() : renderWebApp()}
            <FJModals />
        </>
    );
}

export default App;
